// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  siteKey: '6Lcs9p4UAAAAALlIoaD3Svq_b03N1J6nH8PfKF9Z',
  currentHost: 'http://eservices.showcase.com.ng',
  ESERVICES_URL: 'http://eservices.showcase.com.ng',
  API_SERVER: 'http://eservices.showcase.com.ng/api-server',
  WEB: 'http://eservices.showcase.com.ng',
  WEB2: 'http://eservices.showcase.com.ng',
  REDIRECT: 'http://eservices.showcase.com.ng/redirect',
  FINANCE_API_SERVER: 'http://finance.showcase.com.ng/api-server',
  PROCUREMENT_API_SERVER: 'http://procurement.showcase.com.ng/api-server',
};
// API_SERVER: 'http://eservices2.showcase.com.ng/api-server',
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
